import style from "./ToggleSwitch.css";

const Toggle = ({ isOn }) => {
  const getStyle = () => {
    let baseStyle = style.toggleKnob;
    if (isOn) {
      baseStyle += " " + style.positionRight;
    } else {
      baseStyle += " " + style.positionLeft;
    }
    return baseStyle;
  };
  return <div class={getStyle()}></div>;
};

const ToggleSwitch = ({ isOn, onToggle }) => {
  const getStyle = () => {
    let baseStyle = style.switch;
    if (isOn) {
      baseStyle += " " + style.switchIsOn;
    } else {
      baseStyle += " " + style.switchIsOff;
    }
    return baseStyle;
  };
  return (
    <div class={getStyle()} onClick={onToggle}>
      <Toggle isOn={isOn} />
    </div>
  );
};

export { ToggleSwitch };
